import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  margin: 0 1.5rem;
  position: relative;
`;

const Wrapper = styled.div`
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  background-color: white;
  border-radius: 0.5rem;
  padding: 1rem;
  margin: 0 auto;
  max-width: 24rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  overflow: hidden;
  position: absolute;
  z-index: 10;
  top: 0;
  left: 50%;
  transform: translate(-50%, -60%);

  & > * + * {
    margin-top: 1.25rem;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-content: space-center;
    max-width: 768px;

    & > * + * {
      margin-top: 0;
      margin-left: 1.5rem;
      padding-left: 1.5rem;
      border-left: 1px solid rgb(229, 231, 235);
    }
  }
`;

const Info = styled.div`
  white-space: nowrap;
  flex: 1;

  & > p:first-child {
    font-size: 0.75rem;
    line-height: 1rem;
    text-transform: uppercase;
    color: rgb(107, 114, 128);
    padding-bottom: 0.25rem;
    font-weight: 500;
    letter-spacing: 0.1em;
  }
  & > p:last-child {
    font-size: 1.25rem;
    line-height: 1.75rem;
    font-weight: 600;
  }
`;

function Card({ data = null }) {
  return (
    <Container>
      <Wrapper>
        <Info>
          <p>Ip address</p>
          <p>{data?.ip ?? '-'}</p>
        </Info>
        <Info>
          <p>Location</p>
          <p>
            {data?.city ?? data?.region ?? data?.country_name ?? '-'}{' '}
            {data?.emoji_flag}
          </p>
        </Info>
        <Info>
          <p>Timezone</p>
          <p>{data?.time_zone?.name ?? '-'}</p>
        </Info>
        <Info>
          <p>isp</p>
          <p>{data?.carrier?.name ?? '-'}</p>
        </Info>
      </Wrapper>
    </Container>
  );
}

Card.propTypes = {
  data: PropTypes.object,
};

export default Card;
